import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { useCallback, useEffect } from 'react';

import { fg } from '@confluence/feature-gating';
import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance';
import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys';

import { updateNav4AdminOptInCache } from './nav4AdminOptInCache';

export const useGetNav4OptIn = () => {
	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { loading, data } = useQuery(
		gql`
			query useGetNav4OptInQuery {
				siteSettings {
					isNav4OptedIn
				}
			}
		`,
		{
			skip: !fg('confluence_nav4_ga_phase_1'),
		},
	);

	const updateNav4AdminOptIn = useCallback(async (isNav4OptedIn: boolean) => {
		updateNav4AdminOptInCache(isNav4OptedIn);
	}, []);

	const optInCache = parseCacheValue(localStorage?.getItem(keys.NAV4_ADMIN_OPT_IN_CACHE));
	const optInServer = Boolean(data?.siteSettings?.isNav4OptedIn);
	const nav4AdminOptedIn = fg('confluence_nav4_ga_phase_1') && (loading ? optInCache : optInServer);

	useEffect(() => {
		if (!loading && optInServer !== optInCache) {
			updateNav4AdminOptInCache(optInServer);
		}
	}, [loading, optInCache, optInServer]);

	return {
		nav4AdminOptedIn,
		updateNav4AdminOptIn,
	};
};

const parseCacheValue = (cacheValue: string | null) => {
	if (cacheValue === 'true') {
		return true;
	} else if (cacheValue === 'false') {
		return false;
	} else {
		return undefined;
	}
};
